export default {"src":"/_next/static/media/features-background-right.32f8f570.svg","height":1285,"width":789,"blurWidth":0,"blurHeight":0};